import KeyboardInput from "@common/components/InputKeyboard";
import React from "react";

const KeyboardForCasino = () => {
  return (
    <KeyboardInput class={"input-for-casino"} setFocus={true} casino={true} key={Date.now()} />
  )
}

export default KeyboardForCasino;
